import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { beatBlipSubscriptionConsts } from "src/app/consts/beatBlipSubscriptionConsts";
import { ConfirmationDialogService } from "src/app/test/test-step/confirmation-dialog.service";
import { ProjectService } from "src/app/_services/project.service";
import { TestService } from "src/app/_services/test.service";
import _ from "lodash";
import { UrlService } from "src/app/_services/url.service";
import { MemoryService } from "src/app/_services/memory.service";
import { UserService } from "src/app/_services/user.service";
import { UserMgmtService } from "src/app/_services/user-mgmt.service";
import { HomeService } from "src/app/_services/home.service";

@Component({
  selector: "app-test-module",
  templateUrl: "./test-module.component.html",
  styleUrls: ["./test-module.component.scss"],
})
export class TestModuleComponent implements OnInit {
  // Html element references here
  @ViewChild("cancelUpdateModule") cancelUpdateModule: ElementRef;
  @ViewChild("cancelUpdateSuite") cancelUpdateSuite: ElementRef;
  @ViewChild("cancelAddModule") cancelAddModule: ElementRef;
  @ViewChild("cancelAddTestSuite") cancelAddTestSuite: ElementRef;
  @ViewChild("cancelAddModuleTestSuite") cancelAddModuleTestSuite: ElementRef;
  @ViewChild("cancelAssociationModal") cancelAssociationModal: ElementRef;
  @ViewChild("cancelImportSelenium") cancelImportSelenium: ElementRef;
  @ViewChild("cancelImportTestCase") cancelImportTestCase: ElementRef;
  @ViewChild("cancelAddTestCase") cancelAddTestCase: ElementRef;
  @ViewChild("cancelAddLocatorModule") cancelAddLocatorModule: ElementRef;
  @ViewChild("cancelAddScreen") cancelAddScreen: ElementRef;
  @ViewChild("cancelAddModuleScreen") cancelAddModuleScreen: ElementRef;
  @ViewChild("cancelUpdateLocatorModule") cancelUpdateLocatorModule: ElementRef;
  @ViewChild("cancelUpdateLocatorScreen") cancelUpdateLocatorScreen: ElementRef;
  @ViewChild("cancelImportLocatorScreen") cancelImportLocatorScreen: ElementRef;
  

  //global variables here
  headerOptions = {
    showSetting: true,
    showSearch: false,
    heading: "Module",
    data: undefined,
  };
  projectId: string;
  projectData: any;
  moduleData: any;
  locatorModuleData: any;
  testSuiteData: any;
  locatorScreenData: any;
  moduleRenameForm: UntypedFormGroup;
  locatorModuleRenameForm: UntypedFormGroup;
  locatorScreenRenameForm: UntypedFormGroup;
  suiteRenameForm: UntypedFormGroup;
  addModuleForm: UntypedFormGroup;
  addTestSuiteForm: UntypedFormGroup;
  addTestCaseForm: UntypedFormGroup;
  addLocatorModuleForm: UntypedFormGroup;
  addLocatorScreenForm: UntypedFormGroup;
  selectedModule: any;
  selectedLocator: any;
  selectedScreen: any;
  selectedTestSuite: any;
  isTestSuiteCopied: boolean = false;
  copiedTestSuite: any;
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  projectperpageitem = beatBlipSubscriptionConsts.perpageitem;
  locatorPerPageItem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;
  projectChildren: any;
  locatorChildren: any;
  compareName: any;
  textData: any;
  testDataForAssociation: any;
  associationButton: any;
  disassociationButton: any;
  manageSuiteData: any;
  searchTestData: string;
  activeState: any;
  seleniumFileName: string;
  enableseleniumButton: boolean;
  seleniumFile: any;
  testDataFile: any;
  testDataFileName: any;
  importedTestCase: any;
  enableManual: boolean = false;
  isLocatorView: boolean = false;
  previousUrl: any = [];
  currentUrl: any;
  previousUrltemp: any;
  urlName: string;
  locatorFileName: string;
  locatorCommentMap: {} = {};
  locatorEntryMap: {} = {};
  screenCreateForm: UntypedFormGroup;
  parentId: any;
  parentModule: any[];
  childModule: any[];
  allData: any[];
  breadCrumb=[
    
  ];
  checkForChild: undefined;
  fragmentObj: string;
  agentCheck: boolean;
  ADOCheck =  localStorage.getItem('isADOEnabled') == 'true' ? true : false;
  readOnlyCheck: any;
  suiteReadOnly: any;
  cardView: boolean;
  selectedFile: any;
  moduleNameTest: string ='';
  suiteNameTest: any;
  suiteNameComment: any;
  suiteNameDependent: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private projectService: ProjectService,
    private formBuilder: UntypedFormBuilder,
    private testService: TestService,
    private toastrService: ToastrService,
    private router: Router,
    private urlService: UrlService,
    private testCase:TestService,
    private memoryService:MemoryService,
    private confirmationDialogService: ConfirmationDialogService,
    private userService: UserService,
    private userManagement: UserMgmtService,
    private homeService: HomeService
  ) {}

  ngOnInit() {
    this.initAllForms();
    this.loadUser()
    this.memoryService.getAgentCheck().subscribe(
      (response)=>{
        this.agentCheck = response;}
    )
    this.activatedRoute.paramMap.subscribe((params) => {
      console.log('param',params);
      
      this.projectId = params.get("pid");
      this.projectService.getProjectById(this.projectId).subscribe((res) => {
       
            if(this.agentCheck){
              this.projectService.setProjectDetails(res);
            }
            else{
              try{
                localStorage.setItem('projectDataById', JSON.stringify(res));
              }
              catch{
                this.toastrService.clear();
                this.toastrService.warning('Project size is big please wait untill it loads')
              }
            }

        this.headerOptions.data = {
          projectId: this.projectId,
          projectName: res["projectName"],
        };
        //set header details
        this.homeService.setHeaderOptions(this.headerOptions);
        this.projectService.setProjectDetails(res);
        this.projectData = res;
        // this.loadModules();
        this.loadCopiedTestSuite();
        this.loadLocatorModules();
      });
     
    });
    this.projectService.isLocatorViewActive.subscribe((res)=>
    {
      this.isLocatorView = res;
    })
    this.currentUrl = this.router.url;
    this.previousUrl = this.urlService.captureUrl(this.currentUrl);
    if(!this.agentCheck){

    localStorage.setItem("urlHistory", JSON.stringify(this.previousUrl));
    this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
       this.currentUrl =  this.router.url;
       this.urlName = 'Test-Module';
       this.previousUrl= this.urlService.captureUrl(this.currentUrl,this.urlName,'testModule');
       localStorage.setItem('urlHistory', JSON.stringify(this.previousUrl));
       this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
    }
    else{
      this.memoryService.setUrlHistory(this.previousUrl)
      // localStorage.setItem("urlHistory", JSON.stringify(this.previousUrl));
      this.memoryService.getUrlHistory().subscribe(
        (urlHistory)=>{
          this.previousUrl = urlHistory;
        }
      )
       this.currentUrl =  this.router.url;
       this.urlName = 'Test-Module';
       this.previousUrl= this.urlService.captureUrl(this.currentUrl,this.urlName,'testModule');
       this.memoryService.setUrlHistory(this.previousUrl)
      // localStorage.setItem("urlHistory", JSON.stringify(this.previousUrl));
      this.memoryService.getUrlHistory().subscribe(
        (urlHistory)=>{
          this.previousUrl = urlHistory;
        }
      )
      //  localStorage.setItem('urlHistory', JSON.stringify(this.previousUrl));
      //  this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
    }
       this.loadModules(true);
        }

 desableCardView() {
          this.testCase.setView(false)
          this.changeDefaultView(false);
          this.testCase.getView().subscribe(
            (data) => {
              this.cardView = data;
            }
          );
        }
        enableCardView() {
          this.testCase.setView(true);
          this.changeDefaultView(true);
          this.testCase.getView().subscribe(
            (data) => {
              this.cardView = data;
            }
          );
        
      }
      changeDefaultView(data) {
        this.userManagement.updateDefaultView(data).subscribe((res) => {
          this.toastrService.clear();
          this.toastrService.success("Default view updated successfully");
          this.userService.getUser().subscribe((res: any) => {
            localStorage.setItem('currentUser', JSON.stringify(res));
            this.cardView = res.isCardView == 'true' ? true : false;
            this.testCase.setView(this.cardView);
          })
        })
      }
loadUser()
  {
    if(!JSON.parse(localStorage.getItem('currentUser'))){
      this.userService.getUser().subscribe((res: any)=>{
        this.cardView = res.isCardView == 'true' ? true : false;
      })
    }
    else{
      var resp = JSON.parse(localStorage.getItem('currentUser'));
      this.cardView = resp.isCardView == 'true' ? true : false;
    }
  
  }
  regexStr = '^[a-zA-Z0-9_(){}[] ]+$'
  initAllForms() {
    this.moduleRenameForm = this.formBuilder.group({
      moduleName: [ "", [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
    });
    this.suiteRenameForm = this.formBuilder.group({
      suiteName: ["",[Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      comment: [""],
      dependent: [false],
    });
    this.addModuleForm = this.formBuilder.group({
      moduleName: [ "", [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      comment: [""],
    });

    this.addTestSuiteForm = this.formBuilder.group({
      suiteName: ["", [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      comment: [""],
      dependent: [false],
    });

    this.addTestCaseForm = this.formBuilder.group({
      title: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
      testCaseId: [""],
      dataLabels: [""],
      comment: [""],
      executionIteration: [1, Validators.required],
    });

    let addNewField1 = this.ADOCheck ? this.moduleRenameForm.addControl('adoIntId', this.formBuilder.control('')) : this.moduleRenameForm.removeControl('adoIntId');
    let addNewField2 = this.ADOCheck ? this.suiteRenameForm.addControl('adoIntId', this.formBuilder.control('')) : this.suiteRenameForm.removeControl('adoIntId');
    let addNewField3 = this.ADOCheck ? this.addModuleForm.addControl('adoIntId', this.formBuilder.control('')) : this.addModuleForm.removeControl('adoIntId');
    let addNewField4 = this.ADOCheck ? this.addTestSuiteForm.addControl('adoIntId', this.formBuilder.control('')) : this.addTestSuiteForm.removeControl('adoIntId');
    let addNewField5 = this.ADOCheck ? this.addTestCaseForm.addControl('adoIntId', this.formBuilder.control('')) : this.addTestCaseForm.removeControl('adoIntId'); 

    // Locator Forms below
    this.addLocatorModuleForm = this.formBuilder.group({
      moduleName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });

    this.addLocatorScreenForm = this.formBuilder.group({
      screenName: ["",[Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });

    this.locatorModuleRenameForm = this.formBuilder.group({
      moduleName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });

    this.locatorScreenRenameForm = this.formBuilder.group({
      screenName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });
  }

  // Project tree related methods down below
  reloadComponent() {
    let currentUrl = "/project/module/" + this.projectId;
    this.projectService.setLocatorView(this.isLocatorView);
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  loadModules(isbreadCrumb?:boolean){
    
    this.testService.getAllChildTestDir(this.projectId).subscribe((res) => {
      var moduleArray=res["testSuiteDirData"];
      console.log('moduleAndSuiteData',res["testSuiteDirData"]);
      console.log('SuiteData',res["testSuiteFileData"]);
      var suiteData = res["testSuiteFileData"];
      this.parentModule = [];
      this.allData = [];
      // parentModule['child']=[]
      this.childModule = [];
      // childModule['child']=[]
      if(moduleArray){
        moduleArray.forEach(module => {
          module["type"] = "module";
          module['moduleCount']=0;
          this.allData.push(module)
        });
      }
     if(suiteData){
      suiteData.forEach(suite => {
        suite["type"] = "suite";
        suite['suiteCount']=0;
        this.allData.push(suite);
      });
     }
     
      this.allData.forEach(
        (parentData)=>{
          parentData['suiteCount']=0;
          parentData['moduleCount']=0;
          if(parentData.parentTestDataId){
            this.childModule.push(parentData)
           }
           else{
           this.parentModule.push(parentData);

           }
        }
      )
     
      this.parentModule.forEach(
        (amodule)=>{
          var moduleCount = 0;
          var suiteCount = 0;
          this.childModule.forEach(
            (pModule)=> {
             if(amodule.id==pModule.parentTestDataId && pModule.type=='module'){
              amodule['moduleCount']=++moduleCount;
             }
             if(amodule.id==pModule.parentTestDataId && pModule.type=='suite'){
              amodule['suiteCount']=++suiteCount;
             }
            }
          )
        }
      )
      if(isbreadCrumb){
      this.activatedRoute.fragment.subscribe(
        (fragment)=>{
          if(fragment){
            this.checkForChild=undefined;
            this.changeTab('project');
            this.getChildModule(fragment);
            if(this.agentCheck){
              this.memoryService.getBreadCrumb().subscribe(
                (breadCrumb)=>{
                  this.breadCrumb = breadCrumb;
                }
              )
            }
            else{
              this.breadCrumb = JSON.parse(localStorage.getItem('breadCrumb'))
            }
            
          }
          else{
            localStorage.removeItem('breadCrumb');
            this.checkForChild=undefined;
            this.breadCrumb=[]
            // this.loadModules();
          }
        }
          )
      }
      else if(this.checkForChild){
        this.getChildModule(this.checkForChild,undefined,undefined,undefined,'reload');
      }
      else{
        // localStorage.removeItem('breadCrumb');
            this.checkForChild=undefined;
            // this.breadCrumb=[]
      }
    })
  //   if(isbreadCrumb){
  //    localStorage.removeItem('breadCrumb');
  // }
  
  
  }

  getChildModule(childId,title?:string,isPush?:boolean,index?:any,fromComp?:string){
    console.log(index);
    if(fromComp=='reload'){
      this.checkForChild=undefined;
      this.isLocatorView=false;
    }
    if(this.checkForChild==childId){
      return;
    }
    this.checkForChild = childId
        if(isPush==true){
        var  count=this.breadCrumb.length;
          var breadCrumbObj = 
          {
            id:childId,
            title:title,
            index: count++
          }
        this.breadCrumb.push(breadCrumbObj);
        console.log('child',this.childModule);
        const ids = this.breadCrumb.map(({ title }) => title);
        var tempBreadCrumb = this.breadCrumb.filter(({ title }, index) =>
            !ids.includes(title, index + 1));
          if(this.agentCheck==false) {
            localStorage.setItem('breadCrumb',JSON.stringify(tempBreadCrumb));
            this.breadCrumb = JSON.parse(localStorage.getItem('breadCrumb'))
          }
          else{
            this.memoryService.setBreadCrumb(tempBreadCrumb);
            this.memoryService.getBreadCrumb().subscribe(
              (breadCrumb)=>{
                this.breadCrumb = breadCrumb;
              }
            )
          }
     
      
        }
        else if(isPush==false){
          var tempBc = this.breadCrumb.slice(0, ++index);;
          if(this.agentCheck==false) {
          localStorage.setItem('breadCrumb',JSON.stringify(tempBc));
          this.breadCrumb = JSON.parse(localStorage.getItem('breadCrumb'))
          }
          else{
            this.memoryService.setBreadCrumb(tempBc);
            this.memoryService.getBreadCrumb().subscribe(
              (breadCrumb)=>{
                this.breadCrumb = breadCrumb;
              }
            )
          }
        }
        else{
          this.activatedRoute.fragment.subscribe(
            
            (fragments) => console.log(fragments)
          ); 
        }
    this.parentModule=[]
    var checkForTitle = [];
   this.allData.forEach(
    (cModule)=>{
      if(cModule.parentTestDataId==childId){
        var moduleCount = 0;
        var suiteCount = 0;
        this.allData.forEach(
          (aData)=>{
            if(cModule.id==aData.parentTestDataId && aData.type=='module'){
        
             cModule['moduleCount']= ++moduleCount
            }
            else if(cModule.id==aData.parentTestDataId && aData.type=='suite'){
             
             cModule['suiteCount']= ++suiteCount
            }
          }
        )
        this.parentModule.push(cModule);
      }
    }
   )

   checkForTitle=this.parentModule.filter((f)=>f.type=='module');
   if(checkForTitle.length==0){
    this.headerOptions.heading='Suite';
   }
   else{
    this.headerOptions.heading='Module';
   }

    //set header details
    this.homeService.setHeaderOptions(this.headerOptions);

  }

 
  
  // loadModules() {
    // this.getModuleTree();
    // this.testService.getAllChildTestDir(this.projectId).subscribe((res) => {
    //   console.log('moduleAndSuiteData',res["testSuiteDirData"]);
    //   console.log('SuiteData',res["testSuiteFileData"]);
    //   // localStorage.setItem('getAllChildTestDirResPonse',JSON.stringify(res))
    //   try {
    //     localStorage.setItem('getAllChildTestDirResPonse',JSON.stringify(res))
    //     this.moduleData = [];
    //     this.testSuiteData = [];
    //     this.moduleData = res["testSuiteDirData"]
    //       ? res["testSuiteDirData"].filter((data) => data.path == ",").map((data) => {
    //           data["type"] = "module";
    //           data["children"] = 0;
    //           return data;
    //         })
    //       : undefined;
    //     let suiteData = res["testSuiteFileData"]
    //       ? res["testSuiteFileData"]
    //       : undefined;
    //     if (suiteData) {
    //       this.testSuiteData = suiteData
    //         .filter((data) => data.path == ",")
    //         .map((element) => {
    //           element["type"] = "suite";
    //           return element;
    //         });
    //     }
    //     if (this.moduleData) {
    //       this.moduleData.forEach((module) => {
    //         if(suiteData)
    //         {
    //           suiteData.forEach((suite) => {
    //             if (suite.parentTestDataId && suite.parentTestDataId == module.id) {
    //               module["children"] += 1;
    //             }
    //           });
    //         }
    //       });
    //     }
    //     this.projectChildren = [];
    //     if (this.moduleData) {
    //       this.projectChildren.push(...this.moduleData);
    //     }
    //     if (this.testSuiteData) {
    //       this.projectChildren.push(...this.testSuiteData);
    //     }
    //     console.log('childData',this.projectChildren);
        
    //   } catch (error) {
    //     console.log('error');
    //     this.moduleData = [];
    //     this.testSuiteData = [];
    //     this.moduleData = res["testSuiteDirData"]
    //       ? res["testSuiteDirData"].map((data) => {
    //           data["type"] = "module";
    //           data["children"] = 0;
    //           return data;
    //         })
    //       : undefined;
    //     let suiteData = res["testSuiteFileData"]
    //       ? res["testSuiteFileData"]
    //       : undefined;
    //     if (suiteData) {
    //       this.testSuiteData = suiteData
    //         .filter((data) => data.path == ",")
    //         .map((element) => {
    //           element["type"] = "suite";
    //           return element;
    //         });
    //     }
    //     if (this.moduleData) {
    //       this.moduleData.forEach((module) => {
    //         if(suiteData)
    //         {
    //           suiteData.forEach((suite) => {
    //             if (suite.parentTestDataId && suite.parentTestDataId == module.id) {
    //               module["children"] += 1;
    //             }
    //           });
    //         }
    //       });
    //     }
    //     this.projectChildren = [];
    //     if (this.moduleData) {
    //       this.projectChildren.push(...this.moduleData);
    //     }
    //     if (this.testSuiteData) {
    //       this.projectChildren.push(...this.testSuiteData);
    //     }
    //   }
     
    // });
  // }

  loadLocatorModules() {
    this.projectService
      .getAllChildLocatorDir(this.projectId)
      .subscribe((res) => {
        this.locatorChildren = [];
        this.locatorModuleData = res["locatorDirSuite"]
          ? res["locatorDirSuite"].map((data) => {
              data["type"] = "locatorModule";
              data["children"] = 0;
              return data;
            })
          : undefined;

        let screenData = res["locatorSuite"] ? res["locatorSuite"] : undefined;
        if (screenData) {
          this.locatorScreenData = screenData
            .filter((data) => data["parentLocatorId"] == undefined)
            .map((element) => {
              element["type"] = "locatorScreen";
              return element;
            });
        }

        if (this.locatorModuleData) {
          this.locatorModuleData.forEach((module) => {
            if(screenData)
            {
              screenData.forEach((screen) => {
                if (
                  screen.parentLocatorId &&
                  screen.parentLocatorId == module.id
                ) {
                  module["children"] += 1;
                }
              });
            }
          });
        }

        if (this.locatorModuleData) {
          this.locatorChildren.push(...this.locatorModuleData);
        }
        if (this.locatorScreenData) {
          this.locatorChildren.push(...this.locatorScreenData);
        }

        console.log(this.locatorChildren);
      });
  }

  loadCopiedTestSuite() {
    this.projectService.subjectforTestSuite.subscribe((suite) => {
      this.isTestSuiteCopied = suite ? true : false;
      if (this.isTestSuiteCopied) {
        this.copiedTestSuite = suite;
      } else {
        this.copiedTestSuite = undefined;
      }
    });
  }

  openUpdateModule(module) {
    this.selectedModule = module;
    console.log(JSON.stringify(module.title),module.title);
    this.moduleNameTest = JSON.parse(JSON.stringify(module.title))
    this.moduleRenameForm.patchValue({
      moduleName: module.title
    });
    this.readOnlyCheck = module?.adoIntId
    if(this.ADOCheck)
    {
      this.moduleRenameForm.get('adoIntId').patchValue(module.adoIntId);
    }
  }
  checkName(value){
    console.log(this.moduleNameTest,value);
    
  }
   openUpdateSuite(element) {
    let suite = JSON.parse(JSON.stringify(element));
    this.selectedTestSuite = suite;
    this.selectedTestSuite.dependent = suite.dependent == "true" ? true : false;
    this.suiteNameTest = JSON.parse(JSON.stringify(suite.title))
    this.suiteNameComment = JSON.parse(JSON.stringify(suite.comment))
    this.suiteNameDependent = JSON.parse(JSON.stringify(suite.dependent))
    this.suiteReadOnly = suite?.adoIntId
    this.suiteRenameForm.patchValue({
      suiteName: suite.title,
      comment: suite.comment,
      dependent: suite.dependent,
    });
 
    if(this.ADOCheck)
    {
      this.suiteRenameForm.get('adoIntId').patchValue(suite.adoIntId);
    }
  }

  updateModule() {
    if (this.moduleRenameForm.invalid) {
      this.toastrService.clear();
      this.toastrService.warning('Module name is not Valid')
      return;
    }
    let formValue = this.moduleRenameForm.value;
    console.log(this.selectedModule, formValue.moduleName,this.moduleNameTest);
    let module = {
      title: formValue.moduleName.trim(),
      id: this.selectedModule.id,
      projectId: this.projectId,
    };

    if(this.ADOCheck)
    {
      module['adoIntId'] =  formValue.adoIntId
    }

    if (!/^[^:|*?<>/\\"]+$/.test(formValue.moduleName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Module Name is not Valid, Name cannot contain /[<>:"/\\|?*'
      );
      return;
    }
    this.projectService.editTestDir(module).subscribe((data) => {
      this.toastrService.clear();
      this.toastrService.success("Module updated successfully");
      this.cancelUpdateModule.nativeElement.click();
      this.loadModules();
      if(this.checkForChild){
        //this.getChildModule(this.checkForChild,'reload');
      }
      this.initAllForms();
    });
  }

  updateSuite() {
    if (this.suiteRenameForm.invalid) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Suite name is not Valid'
      );
      return;
    }
    let formValue = this.suiteRenameForm.value;
    if (!/^[^:|*?<>/\\"]+$/.test(formValue.suiteName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Suite name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }
    let valueForUpdate = {
      title: formValue.suiteName.trim(),
      comment: formValue.comment,
      projectId: this.selectedTestSuite.projectId,
      id: this.selectedTestSuite.id,
      dependent: formValue.dependent,
      parentTestDataId: this.selectedTestSuite.parentTestDataId
    };

    if(this.ADOCheck)
    {
      valueForUpdate['adoIntId'] =  formValue.adoIntId
    }

    this.testService.editTestFile(valueForUpdate).subscribe((data) => {
      this.cancelUpdateSuite.nativeElement.click();
      this.loadModules();
      if(this.checkForChild){
        //this.getChildModule(this.checkForChild,'reload');
      }
      this.projectService.sendUpdateData(data);
      this.toastrService.success("Suite updated successfully");
    });
  }


  addModule() {
    if (this.addModuleForm.invalid) {
      return;
    }
    var formValue = this.addModuleForm.value

    let ValueForAdd = {
      title: formValue.moduleName.trim(),
      comment: formValue.comment,
      projectId: this.projectId
    };
    
    if(this.checkForChild){
      ValueForAdd['parentTestDataId']=this.checkForChild;
    }
    if(this.ADOCheck)
    {
      ValueForAdd['adoIntId'] =  formValue.adoIntId
    }

    if (!/^[^:|*?<>/\"]+$/.test(formValue.moduleName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Module Name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }

    this.projectService.addTestDir(ValueForAdd).subscribe((data) => {
      if (data) {
        this.toastrService.clear();
        this.toastrService.success(" Module Added successfully");
        let ValueForAdd1 = {
          dependent: "false",
          title: "Default Suite",
          comment: "process",
          projectId: data["projectId"],
          parentTestDataId: data["id"],
        };

        this.projectService.addTestSuite(ValueForAdd1).subscribe((data) => {
          if (data) {
            this.cancelAddModule.nativeElement.click();
            this.loadModules();
            if(this.checkForChild){
              //this.getChildModule(this.checkForChild,'reload');
            }
          }
        });
      }
    });
  }

  addTestSuite() {
    if (this.addTestSuiteForm.invalid) {
      return;
    }
    var formValue = this.addTestSuiteForm.value;

    if (!/^[^:|*?<>/\\"]+$/.test(formValue.suiteName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Suite Name is not Valid, Name cannot contain /[<>:"/\\|?*'
      );
      return;
    }

    let ValueForAdd = {
      title: formValue.suiteName.trim(),
      comment: formValue.comment,
      dependent: formValue.dependent,
      projectId: this.projectId
    };

    if(this.checkForChild){
      ValueForAdd['parentTestDataId']=this.checkForChild;
    }

    if(this.ADOCheck)
    {
      ValueForAdd['adoIntId'] =  formValue.adoIntId
    }

    this.projectService.addTestSuite(ValueForAdd).subscribe((res) => {
      if (res) {
        this.toastrService.clear();
        this.toastrService.success("Suite Added successfully");
        this.cancelAddTestSuite.nativeElement.click();
        this.loadModules();
        if(this.checkForChild){
          //this.getChildModule(this.checkForChild,'reload');
        }
      }
    });
  }

  deleteModule(module) {
    this.confirmationDialogService
      .openConfirmDialog("Are you sure to delete " + module.title + " ?")
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.projectService
            .deleteModule(this.projectId, module.id)
            .subscribe((res) => {
              this.toastrService.clear();
              this.toastrService.success("Module deleted successfully");
              this.loadModules();
              if(this.checkForChild){
                //this.getChildModule(this.checkForChild,'reload');
        }
            });
        }
      });
  }

  deleteTestSuite(suite) {
    console.log(suite);
    this.confirmationDialogService
      .openConfirmDialog("Are you sure to delete " + suite.title + " ?")
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.projectService
            .deleteModule(this.projectId, suite.id)
            .subscribe((res) => {
              this.toastrService.clear();
              this.toastrService.success("Suite deleted successfully");
              this.loadModules();
              if(this.checkForChild){
                //this.getChildModule(this.checkForChild,'reload');
        }
            });
        }
      });
  }

  addTestSuiteInsideModule() {
    if (this.addTestSuiteForm.invalid) {
      return;
    }
    var formValue = this.addTestSuiteForm.value;

    if (!/^[^:|*?<>/\\"]+$/.test(formValue.suiteName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Suite Name is not Valid, Name cannot contain /[<>:"/\\|?*'
      );
      return;
    }

    let ValueForAdd = {
      title: formValue.suiteName.trim(),
      comment: formValue.comment,
      dependent: formValue.dependent,
      projectId: this.projectId,
      parentTestDataId: this.selectedModule.id
    };

    if(this.ADOCheck)
    {
      ValueForAdd['adoIntId'] =  formValue.adoIntId
    }

    this.projectService.addTestSuite(ValueForAdd).subscribe((res) => {
      if (res) {
        this.toastrService.clear();
        this.toastrService.success("Suite Added successfully");
        this.cancelAddModuleTestSuite.nativeElement.click();
        this.loadModules();
        if(this.checkForChild){
          //this.getChildModule(this.checkForChild,'reload');
        }
      }
    });
  }

  pasteProcess() {
    this.testService
      .pasteSuite(
        this.projectId,
        this.selectedModule.id,
        this.copiedTestSuite.id
      )
      .subscribe((data) => {
        this.loadModules();
        this.toastrService.clear();
        this.toastrService.success("Suite pasted successfully");
        this.projectService.subjectforTestSuite.next(null);
      });
  }

  restoreSuiteData(suite) {
    let projectId = suite.projectId;
    let suiteId = suite.id;
    let arrayData = [];
    this.projectService
      .restoreSuite(projectId, suiteId, arrayData)
      .subscribe((data) => {
        this.toastrService.clear();
        this.toastrService.success('Restored Successfully')
        this.loadModules();
        if(this.checkForChild){
          //this.getChildModule(this.checkForChild,'reload');
        }
      });
  }

  copySuite(suite) {
    this.projectService.subjectforTestSuite.next(suite);
    this.toastrService.clear();
    this.toastrService.info("Suite copied successfully");
  }

  association(item) {
    this.searchTestData = "";
    this.compareName = "";
    this.projectService.getDefaultTextData(this.projectId).subscribe((data) => {
      this.textData = data["textData"];
      this.testDataForAssociation = this.textData.filter(
        (f) => f.name == item.testDataSourceName.name
      );
      if (this.testDataForAssociation.length > 0) {
        this.compareName = this.testDataForAssociation[0].name;
        this.associationButton = true;
      } else {
        this.compareName = "";
      }
      if (this.compareName.length > 2) {
        this.disassociationButton = false;
      } else {
        this.disassociationButton = true;
      }
    });

    this.testService.getSuitData(this.projectId, item.id).subscribe((data) => {
      this.manageSuiteData = data;
    });
  }

  associateData(name, settingName) {
    if (this.compareName == name) {
      this.activeState = name;
      this.disassociationButton = false;
      this.associationButton = true;
    } else if (this.compareName != name) {
      this.activeState = name;
      this.associationButton = false;
      this.disassociationButton = true;
    }

    var obj = {
      name: name,
      settingName: settingName,
    };
    this.manageSuiteData.testDataSourceName = obj;
  }

  disassociate() {
    this.testDataForAssociation;
    var obj = {
      name: this.testDataForAssociation[0].name,
      settingName: this.testDataForAssociation[0].settingName,
    };
    delete this.manageSuiteData.testDataSourceName;
    this.testService
      .editTestSuiteData(this.manageSuiteData)
      .subscribe((data) => {
        this.toastrService.success("Entity Updated Successfully");
        this.cancelAssociationModal.nativeElement.click();
        this.loadModules();
        if(this.checkForChild){
          //this.getChildModule(this.checkForChild,'reload');
        }
      });
  }

  submitAssoiciatedData() {
    this.manageSuiteData = _.omit(this.manageSuiteData, [
      "testCaseData",
      "dynamicTestResult",
      "active",
      "execuationIteration",
      "executionCount",
      "path",
      "runState",
      "selectedState",
      "content",
    ]);

    this.testService
      .editTestSuiteData(this.manageSuiteData)
      .subscribe((data) => {
        this.toastrService.clear();
        this.toastrService.success("Entity Updated Successfully");
        this.cancelAssociationModal.nativeElement.click();
        this.loadModules();
        if(this.checkForChild){
          //this.getChildModule(this.checkForChild,'reload');
        }
      });
  }

  resetSeleniumModel() {
    this.seleniumFileName = "";
    this.seleniumFile = File;
    this.enableseleniumButton = false;
  }

  uploadSeleniumData(event: any) {
    this.resetSeleniumModel();
    this.enableseleniumButton = true;
    this.seleniumFile = event.target.files[0];
    this.seleniumFileName = this.seleniumFile.name.substring(
      0,
      this.seleniumFile.name.lastIndexOf(".")
    );
  }

  onImportSeleniumFile() {
    if (this.seleniumFile == undefined) {
      return;
    }
    var fd = new FormData();
    fd.append("file", this.seleniumFile);
    this.projectService
      .uploadSelenium(this.projectId, this.selectedTestSuite.id, fd)
      .subscribe((res) => {
        this.seleniumFileName = "";
        this.toastrService.success("Recorded file uploaded successfully");
        this.cancelImportSelenium.nativeElement.click();
        this.projectService.sendUpdateData(res);
        this.resetSeleniumModel();
        this.loadModules();
      });
  }

  onProjectPageChange(newValue) {
    this.selectedPage = newValue;
    this.projectperpageitem = newValue;
  }

  onLocatorPageChange(newValue) {
    this.selectedPage = newValue;
    this.locatorPerPageItem = newValue;
  }

  onImportTestCase() {
    {
      if (this.testDataFile == undefined) {
        return;
      }
      var fd = new FormData();
      fd.append("file", this.testDataFile);
      this.projectService
        .uploadTestCase(this.projectId, this.selectedTestSuite.id, fd)
        .subscribe((res) => {
          this.cancelImportTestCase.nativeElement.click();
          this.importedTestCase = res["testCaseData"];
          if (this.importedTestCase) {
            this.loadModules();
            var testCaseName = [];
            var showToaster = false;
            var counter = 1;
            var toastrMsg = "<h5>Following Cases are imported : <h5> <br/>";
            for (let i = 0; i < this.importedTestCase.length; i++) {
              toastrMsg +=
                counter++ + ". " + this.importedTestCase[i].title + "<br/>";
              showToaster = true;
            }
            if (showToaster) {
              this.toastrService.clear();
              this.toastrService.info(toastrMsg, null, {
                enableHtml: true,
                tapToDismiss: false,
              });
            }
            this.projectService.sendTestData(this.importedTestCase);
          } else {
            this.toastrService.clear();
            this.toastrService.warning("Selected test file already exist");
          }
        });
    }
  }

  uploadTestCase(event: any) {
    this.selectedFile = event;
    this.testDataFile = event.target.files[0];
    this.testDataFileName = this.testDataFile.name;
    event.preventDefault()
  }

 
  resetTestDataModel() {
    this.testDataFileName = "";
    this.testDataFile = undefined;
  }
  onCreateTestCase() {
    if (this.addTestCaseForm.invalid) {
      return;
    }
    var objFormval = this.addTestCaseForm.value;
    if (this.enableManual) {
      objFormval.testCaseType = "MANUAL";
    }

    this.testService
      .addTestCase(this.projectId, this.selectedTestSuite.id, objFormval)
      .subscribe((data) => {
        this.projectService.sendUpdateData(data);
        this.cancelAddTestCase.nativeElement.click();
        this.loadModules();
        this.toastrService.clear();
        this.toastrService.success(" New Case Added successfully");
      });
  }

  clearTag() {
    this.addTestCaseForm.patchValue({
      dataLabels: "",
    });
  }

  // Locator Tree related methods down below

  addLocatorModule() {
    if (this.addLocatorModuleForm.invalid) {
      return;
    }
    var formValue = this.addLocatorModuleForm.value;

    let ValueForAdd = {
      name: formValue.moduleName.trim(),
      projectId: this.projectId,
    };

    if (!/^[^:|*?<>/\"]+$/.test(formValue.moduleName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Module Name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }

    this.projectService.addLocator(ValueForAdd).subscribe((data) => {
      if (data) {
        this.toastrService.clear();
        this.toastrService.success(" Module Added successfully");
        let ValueForAdd1 = {
          name: formValue.moduleName + "Screen",
          projectId: data["projectId"],
          parentLocatorId: data["id"],
        };

        this.projectService.addScreen(ValueForAdd1).subscribe((data) => {
          if (data) {
            this.cancelAddLocatorModule.nativeElement.click();
            this.loadLocatorModules();
          }
        });
      }
    });
  }

  addScreen() {
    if (this.addLocatorScreenForm.invalid) {
      return;
    }
    var formValue = this.addLocatorScreenForm.value;

    let ValueForAdd = {
      name: formValue.screenName.trim(),
      projectId: this.projectId,
    };

    if (!/^[^:|*?<>/\"]+$/.test(formValue.moduleName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Module Name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }

    this.projectService.addScreen(ValueForAdd).subscribe((data) => {
      if (data) {
        this.toastrService.clear();
        this.toastrService.success("Screen Added successfully");
        this.cancelAddScreen.nativeElement.click();
        this.loadLocatorModules();
      }
    });
  }

  addScreenInsideModule() {
    if (this.addLocatorScreenForm.invalid) {
      return;
    }
    var formValue = this.addLocatorScreenForm.value;

    let ValueForAdd = {
      name: formValue.screenName.trim(),
      parentLocatorId: this.selectedLocator.id,
      projectId: this.projectId,
    };

    if (!/^[^:|*?<>/\"]+$/.test(formValue.screenName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Screen Name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }

    this.projectService.addScreen(ValueForAdd).subscribe((data) => {
      if (data) {
        this.toastrService.clear();
        this.toastrService.success("Screen Added successfully");
        this.cancelAddModuleScreen.nativeElement.click();
        this.loadLocatorModules();
      }
    });
  }

  deleteLocatorModule(module) {
    this.confirmationDialogService
      .openConfirmDialog("Are you sure to delete " + module.name + " ?")
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.projectService
            .deleteLocator(this.projectId, module.id)
            .subscribe((res) => {
              this.toastrService.clear();
              this.toastrService.success("Module deleted successfully");
              this.loadLocatorModules();
            });
        }
      });
  }

  openUpdateLocatorModule(module) {
    this.selectedLocator = module;
    this.locatorModuleRenameForm.patchValue({
      moduleName: module.name,
    });
  }

  updateLocatorModule() {
    if (this.locatorModuleRenameForm.invalid) {
      return;
    }
    let formValue = this.locatorModuleRenameForm.value;
    console.log(this.selectedModule, formValue);
    let module = {
      name: formValue.moduleName.trim(),
      id: this.selectedLocator.id,
      projectId: this.projectId,
    };

    if (!/^[^:|*?<>/\\"]+$/.test(formValue.moduleName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Module Name is not Valid, Name cannot contain /[<>:"/\\|?*'
      );
      return;
    }
    this.projectService.editLocatorDirSuiteTitle(module).subscribe((data) => {
      this.toastrService.clear();
      this.toastrService.success("Module updated successfully");
      this.cancelUpdateLocatorModule.nativeElement.click();
      this.loadLocatorModules();
      this.initAllForms();
    });
  }

  deleteScreen(screen) {
    this.confirmationDialogService
      .openConfirmDialog(
        "Are you sure you want to delete " + screen.name + " ?"
      )
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.projectService
            .deleteLocator(this.projectId, screen.id)
            .subscribe((data) => {
              this.toastrService.clear();
              this.toastrService.success("Screen deleted successfully");
              this.loadLocatorModules();
            });
        }
      });
  }

  openUpdateLocatorScreen(screen) {
    this.selectedScreen = screen;
    this.locatorScreenRenameForm.patchValue({
      screenName: screen.name,
    });
  }

  updateLocatorScreen() {
    if (this.locatorScreenRenameForm.invalid) {
      return;
    }
    let formValue = this.locatorScreenRenameForm.value;
    console.log(this.selectedModule, formValue);
    let screen = {
      name: formValue.screenName,
      id: this.selectedScreen.id,
      projectId: this.projectId,
    };

    if (!/^[^:|*?<>/\\"]+$/.test(formValue.screenName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Screen Name is not Valid, Name cannot contain /[<>:"/\\|?*'
      );
      return;
    }
    this.projectService.editLocatorSuitTitle(screen).subscribe((data) => {
      this.toastrService.clear();
      this.toastrService.success("Screen updated successfully");
      this.cancelUpdateLocatorScreen.nativeElement.click();
      this.loadLocatorModules();
      this.initAllForms();
    });
  }

  changeTab(type: string) {
    this.isLocatorView = type == "locator" ? true : false;
    this.headerOptions.heading =
      type == "locator" ? "Locator Module" : "Test Module";
    //set header details
    this.homeService.setHeaderOptions(this.headerOptions);
  }
  initScreenCreateForm(child?:any) {
    this.parentId = child.id;
    this.screenCreateForm = this.formBuilder.group({
      screenName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });
    this.locatorFileName = "";

    // if(this.isLocatorTestSuiteSelected)
    // {
    //   this.toastrService.clear();
    //   this.toastrService.warning("please select a project or a test module");
    // }
  }
  resetImportLocator() {
    this.locatorFileName = "";
    this.locatorCommentMap = {};
    this.locatorEntryMap = {};
  }
  
  onImportLocators() {
    if (
      this.locatorFileName != "" &&
      this.locatorCommentMap != {} &&
      this.locatorEntryMap != {}
    ) {
      let obj = {
        projectId: this.projectId,
        parentLocatorId: this.parentId,
        name: this.locatorFileName,
        locatorEntryMap: this.locatorEntryMap,
        locatorCommentMap: this.locatorCommentMap,
      };

      this.projectService.addScreen(obj).subscribe((res) => {
        //console.log(res);
        this.toastrService.success("Screen imported successfully");
        this.cancelImportLocatorScreen.nativeElement.click();
        this.projectService.sendLocatorData(this.projectId);
        this.resetImportLocator();
        this.loadLocatorModules();
      });
    }
  }
  
  uploadLocator(event: any) {
    let file = event.target.files[0];
    let extension = file.type;
    //console.log(file)
    this.locatorFileName = file.name.substring(0, file.name.lastIndexOf("."));
    var fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onload = (e) => {
      let contentList = fileReader.result.toString().split("\n");
      //console.log(contentList);

      var locatorData = new Array();
      var commentData = new Array();

      var comment = undefined;

      contentList.forEach((data) => {
        data = data.trim();
        if (data !== null && data.length > 0) {
          if (data.indexOf("#") === 0) {
            comment = data.substring(1);
          }
          var entry = {};
          var commentEntry = {};
          if ("csv" === extension) {
            entry["key"] = data
              .substring(0, data.indexOf(","))
              .replace(/["]+/g, "");
            entry["value"] = data
              .substring(data.indexOf(",") + 1)
              .replace(/["]+/g, "");
          } else {
            entry["key"] = data.substring(0, data.indexOf("="));
            entry["value"] = data.substring(data.indexOf("=") + 1);
          }
          commentEntry["key"] = entry["key"];
          if (comment != undefined) {
            commentEntry["value"] = comment;
          }
          commentData.push(commentEntry);
          comment = undefined;
          locatorData.push(entry);
        }
      });

      this.locatorEntryMap["entry"] = locatorData;
      this.locatorCommentMap["entry"] = commentData;
    };
  }

  restoreProcess(child){
    console.log(child);
    this.projectService.restoreFiles(child.projectId, child.id).subscribe(
      (data)=>{
        this.loadModules();
        this.toastrService.clear();
        this.toastrService.success('Restored Successfully')
      }
    )
    
  }

}
